class BackgroundLazyLoader {

    private lazyImages: NodeListOf<Element>;
    readonly imgClassName: string;

    constructor(option: { className: string }) {

        this.imgClassName = option.className;
        // console.log(this.imgClassName.split('.'));
        this.lazyImages = document.querySelectorAll(this.imgClassName);
        this.init();
    }

    private init(): void {

        if ("IntersectionObserver" in window) {
            this.createLazyByObserver();
        } else {
            if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
                console.log('This is IE 10');
                for (let i: number = 0; i < this.lazyImages.length; i++) {
                    let img: any = this.lazyImages[i];
                    img.classList.remove("lazy");
                }
            } else {
                this.createLazyByEvent();
            }
        }
    }

    /**
     * Lazy by Observe
     * */
    private imgObserver: IntersectionObserver;

    private createLazyByObserver(): void {

        this.imgObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {

                    let removeClassName: string = this.imgClassName.split('.')[1];
                    let image = entry.target;
                    image.classList.remove(removeClassName);
                    this.imgObserver.unobserve(image);
                }
            });
        });
        this.lazyImages.forEach((image) => {
            this.imgObserver.observe(image);
        });
    }


    /**
     * Lazy by Event
     * */
    private loadTimer: any;

    private createLazyByEvent(): void {
        document.addEventListener("scroll", () => this.lazyLoad());
        window.addEventListener("resize", () => this.lazyLoad());
        window.addEventListener("orientationChange", () => this.lazyLoad());
        this.lazyLoad();
    }

    private lazyLoad(): void {

        if (this.loadTimer) {
            window.clearTimeout(this.loadTimer);
            this.loadTimer = null;
        }
        this.loadTimer = window.setTimeout(() => {
            let scrollTop: number = window.pageYOffset;
            for (let i: number = 0; i < this.lazyImages.length; i++) {
                let img: any = this.lazyImages[i];
                if (img.offsetTop < (window.innerHeight + scrollTop)) {
                    let removeClassName: string = this.imgClassName.split('.')[1];
                    img.classList.remove(removeClassName);
                }
            }
            /* this.lazyImages.forEach((img: HTMLElement) => {
                 console.log("xxx", img);
                 if (img.offsetTop < (window.innerHeight + scrollTop)) {
                     let removeClassName: string = this.imgClassName.split('.')[1];
                     img.classList.remove(removeClassName);
                 }
             });*/
            if (this.lazyImages.length == 0) {
                document.removeEventListener("scroll", () => this.lazyLoad());
                window.removeEventListener("resize", () => this.lazyLoad());
                window.removeEventListener("orientationChange", () => this.lazyLoad());
            }
        }, 20);
    }
}

export = BackgroundLazyLoader;